// Authentik OIDC 設定 —— 請填入實際值後再啟用登入功能。
// 所有欄位留空時，AuthContext 會判定為「OIDC 尚未設定」，點登入會顯示提示而不會壞掉。
const authentikConfig = {
  // Authentik issuer（例如 https://auth.example.com/application/o/radio-recording/）
  issuer: 'https://auth.nogi46.me/application/o/eystudio-radio-recorder/',
  // Application 的 client_id
  clientId: 'RaeMfMFbM1hPlpHjFHfipCMIPYphdnJhzHPMJuVe',
  // OAuth redirect，需與 Authentik 設定完全一致（本專案回呼頁面為 /callback）
  redirectUri:
    typeof window !== 'undefined' ? `${window.location.origin}/callback` : '',
  // 要申請的 scope
  scope: 'openid profile email',
  // Authentik 的 authorize/token/userinfo 是全域端點（不帶 application slug），
  // 必須顯式覆寫，否則 getAuthEndpoints() 會用 issuer 組出帶 slug 的錯誤路徑導致 404。
  authorizationEndpoint: 'https://auth.nogi46.me/application/o/authorize/',
  tokenEndpoint: 'https://auth.nogi46.me/application/o/token/',
  userinfoEndpoint: 'https://auth.nogi46.me/application/o/userinfo/',
  endSessionEndpoint:
    'https://auth.nogi46.me/application/o/eystudio-radio-recorder/end-session/',
};

export function isAuthentikConfigured() {
  return Boolean(
    authentikConfig.issuer &&
      authentikConfig.clientId &&
      authentikConfig.redirectUri
  );
}

export function getAuthEndpoints() {
  const issuer = authentikConfig.issuer.replace(/\/$/, '');
  return {
    authorization:
      authentikConfig.authorizationEndpoint || `${issuer}/authorize/`,
    token: authentikConfig.tokenEndpoint || `${issuer}/token/`,
    userinfo: authentikConfig.userinfoEndpoint || `${issuer}/userinfo/`,
    endSession:
      authentikConfig.endSessionEndpoint || `${issuer}/end-session/`,
  };
}

export default authentikConfig;
